// eslint-disable-next-line unicode-bom
import axios from 'axios';

export async function syncMetaFlows(accountId) {
  if (!accountId) throw new Error('accountId is required');
  const url = `${window.API_BASE_URL}/Meta/Flows/Sync/${accountId}`;
  const res = await axios.post(url);
  return res.data;
}

export async function getMetaFlows(accountId) {
  if (!accountId) throw new Error('accountId is required');
  const url = `${window.API_BASE_URL}/Meta/Flows/${accountId}`;
  const res = await axios.get(url);
  return res.data;
}
